module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-1-f03cca95b51c732efb6d325e72dcc06f.jpg";